import React, { useMemo } from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';
import Icon from 'utils/components/icon';
import dayjs from 'dayjs';

interface Props {
  title: any;
  timestamp: number;
  published?: boolean;
  icon?: React.ReactElement;
  reason?: any;
  color?: 'black' | 'green' | 'red';
}

const MessageLogInfo: React.FC<Props> = ({
  title,
  timestamp,
  published = true,
  icon,
  reason,
  color = 'black'
}) => {
  const date = useMemo(() => {
    const day = dayjs(timestamp).date();
    const month = dayjs(timestamp).format('MMM');
    const hour = dayjs(timestamp).format('H:mm');
    const year = dayjs(timestamp).format('YYYY');

    return `${hour}, ${month} ${day}, ${year}`;
  }, [timestamp]);

  return (
    <div className={styles.container}>
      {icon && <div className={styles.messageLogIcon}>{icon}</div>}
      <div className={styles.infoContainer}>
        <div className={styles.messageStatus}>
          <span className={styles[color]} data-testid={'message-log-info-title'}>
            {title}
            {published && (
              <Icon name="published" className={classnames(styles.published, 'published-icon')} />
            )}
          </span>
        </div>
        {reason && <span className={classnames(styles[color], styles.reason)}>({reason})</span>}
        <span className={styles.date}>{date}</span>
      </div>
    </div>
  );
};

export default MessageLogInfo;
